<template>
  <div v-if="!loading">
    <div class="box p-4">
      <div class="left-side">
        <v-calendar
          :key="employeeAbsences.length"
          ref="employeeCalendar"
          class="calendar"
          :attributes="[
            ...scheduledAttributes,
            ...orderedAttributes,
            ...absencesAttributes,
          ]"
          @dayclick="onDayClick"
          @transition-end="onMonthChange"
        />

        <div
          class="p-0 mb-4 scheduled-employee-label"
          v-if="selectedDayCustomers && selectedDayCustomers.length > 0"
        >
          <p class="m-0">{{ selectedDayCustomers[0].date }}</p>
          <p class="m-0">Podopieczny</p>

          <span
            class="scheduled-employee"
            v-for="customer of selectedDayCustomers"
            :key="customer.customer"
          >
            <p class="p-0 m-0">
              {{ customer.customer }}
              <img
                @click="removeSingleDayInOrder(customer)"
                class="ml-2 cursor-pointer"
                src="../../icons/dod/dodCircleRemove.svg"
                alt="Remove"
              />
            </p>
            <!-- <p class="customer-scheduled-days-info">
              Liczba zaplanowanych godzin opiekuna:
              {{ customer.numberOfScheduledHours }}
            </p> -->
          </span>
        </div>

        <div class="selected-absence p-0 m-0" v-if="selectedAbsence">
          <p class="p-0">
            <span><b>Nieobecność opiekuna dnia: </b></span>
            {{ selectedAbsence }}
          </p>
          <p
            class="delete-absence p-0 m-0"
            @click="deleteAbsence(selectedAbsence)"
          >
            Usuń
          </p>
        </div>

        <div
          class="p-0 mb-4 scheduled-employee-label"
          v-if="selectedDayScheduled"
        >
          Brak opiekuna
        </div>

        <p
          class="ml-1 add-absence-button"
          @click="addingAbsenceVisible = !addingAbsenceVisible"
        >
          Dodaj niebecność opiekuna
        </p>

        <adding-employee-absence
          v-if="addingAbsenceVisible"
          @cancel="addingAbsenceVisible = false"
          :employeeId="employeeId"
          @absenceAdded="absenceAdded"
        />
      </div>
      <div class="right-side">
        <p>
          <span class="data-label">Il. godz. zleconych:</span>
          <span class="data-value">{{ numberOfOrderedHours }}</span>
        </p>

        <p>
          <span class="data-label">Suma godz. wykonanych:</span>
          <span class="data-value">{{ numberOfMadeHours }}</span>
        </p>

        <p>
          <span class="data-label">Wynagrodzenie brutto:</span>
          <span class="data-value"
            >{{ grossWage }} zł
            <span v-if="hourlyRate">({{ hourlyRate }} zł/h)</span></span
          >
        </p>

        <p>
          <span class="data-label">Il. godz. niezrealizowanych:</span>
          <span class="data-value">{{ numberOfUnrealizedHours }}</span>
        </p>

        <p v-if="settlement">
          <span class="data-label">Status rozliczenia:</span>
          <settlement-status-badge :status="settlement.status" />
        </p>
        <p v-if="settlement && settlement.lastChangeAt" class="last-change">
          Ostatnia zmiana: {{ settlement.lastChangeByName }}
          {{ formatDateTime(settlement.lastChangeAt) }}
        </p>

        <div class="settlement-actions" v-if="settlement">
          <button
            v-if="settlement.status === 'NIEROZLICZONO'"
            class="btn-prepare"
            :disabled="!settlement.permissions.canEdit"
            @click="openSettlement"
          >
            Przygotuj rozliczenie
          </button>
          <template v-else>
            <button
              class="btn-edit"
              :disabled="!settlement.permissions.canEdit"
              @click="openSettlement"
            >
              Edytuj
            </button>
            <button class="btn-history" @click="historyModalVisible = true">
              Historia zmian
            </button>
          </template>
        </div>
      </div>
    </div>

    <settlement-modal
      :visible="settlementModalVisible"
      :employee-id="employeeId"
      :month="settlementMonth"
      :year="settlementYear"
      :mode="settlementMode"
      @close="settlementModalVisible = false"
      @changed="onSettlementChanged"
    />
    <settlement-history-modal
      :visible="historyModalVisible"
      :employee-id="employeeId"
      :employee-name="settlement ? settlement.employeeName : ''"
      :month="settlementMonth"
      :year="settlementYear"
      @close="historyModalVisible = false"
    />

    <p
      class="ml-4 pl-3 availability-button"
      @click="changingScheduleView = !changingScheduleView"
    >
      DYSPOZYCYJNOŚĆ
    </p>
    <employee-schedule-editing
      v-if="changingScheduleView"
      :employeeId="employeeId"
      @cancelEditing="changingScheduleView = false"
    />

    <dod-employee-orders :employeeId="employeeId" @deleteOrder="deleteOrder" />
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import EmployeeScheduleEditing from "./EmployeeScheduleEditing.vue";
import moment from "moment";
import AddingEmployeeAbsence from "./AddingEmployeeAbsence.vue";
import DodEmployeeOrders from "./DodEmployeeOrders.vue";
import SettlementModal from "./settlement/SettlementModal.vue";
import SettlementHistoryModal from "./settlement/SettlementHistoryModal.vue";
import SettlementStatusBadge from "./settlement/SettlementStatusBadge.vue";
export default {
  name: "EmployeeSchedule",
  components: {
    VCalendar,
    EmployeeScheduleEditing,
    AddingEmployeeAbsence,
    DodEmployeeOrders,
    SettlementModal,
    SettlementHistoryModal,
    SettlementStatusBadge,
  },
  props: ["employeeId"],
  data: () => {
    return {
      loading: true,
      addingAbsenceVisible: false,
      calendarMonth: null,
      changingScheduleView: true,
      calendarAttributes: [],
      selectedDayCustomers: [],
      selectedDayScheduled: false,
      selectedAbsence: null,
      lastClickedDay: null,
      settlement: null,
      settlementModalVisible: false,
      settlementMode: "employee",
      historyModalVisible: false,
      settlementMonth: null,
      settlementYear: null,
    };
  },

  async mounted() {
    const now = moment();
    // Deep-link z powiadomienia (cofnięcie do poprawy): ?month&year.
    const queryMonth = Number(this.$route.query.month);
    const queryYear = Number(this.$route.query.year);
    const useMonth = queryMonth || now.get("month") + 1;
    const useYear = queryYear || now.get("year");
    let monthStr = useMonth < 10 ? "0" + useMonth : useMonth;
    this.calendarMonth = `${useYear}-${monthStr}`;

    await this.fetchEmployeeData(useMonth, useYear);
    this.loading = false;
    if (queryMonth && queryYear) {
      this.$nextTick(() => {
        if (this.$refs["employeeCalendar"]) {
          this.$refs["employeeCalendar"].move({
            month: queryMonth,
            year: queryYear,
          });
        }
      });
    }
  },
  methods: {
    removeSingleDayInOrder(customer) {
      if (
        confirm("Czy na pewno chcesz usunąć tego podopiecznego z tego dnia?")
      ) {
        this.confirmRemoveSingleDayInOrder(customer);
      }
    },
    async confirmRemoveSingleDayInOrder(customer) {
      const year = this.$refs["employeeCalendar"]._data.pages[0].year;
      const month = this.$refs["employeeCalendar"]._data.pages[0].month;
      await this.$store.dispatch("removeSingleDay", {
        orderId: customer.orderId,
        date: customer.date,
      });

      await this.fetchEmployeeData(month, year);
      this.onDayClick(this.lastClickedDay);
    },

    async deleteOrder(order) {
      const year = this.$refs["employeeCalendar"]._data.pages[0].year;
      const month = this.$refs["employeeCalendar"]._data.pages[0].month;
      try {
        await this.$store.dispatch("deleteDodOrder", {
          orderId: order.id,
          year,
          month,
        });
        this.fetchEmployeeData(month, year);
      } catch (error) {
        // Backend DOD zawsze zwraca `message` jako polski string - pokaż go; generyk tylko
        // gdy błąd nie ma treści (sieć, 5xx).
        const backendMsg =
          error && error.response && error.response.data && error.response.data.message;
        this.$notify({
          group: "error",
          text:
            typeof backendMsg === "string" && backendMsg
              ? backendMsg
              : "Nie udało się usunąć zlecenia",
        });
      }
    },

    async absenceAdded(date) {
      let [year, month] = date.split("-");
      this.$refs["employeeCalendar"].move({
        month: Number(month),
        year: Number(year),
      });
    },
    async fetchEmployeeData(month, year) {
      await this.$store.dispatch("getEmployeeOrders", {
        employeeId: this.employeeId,
        ordersMonth: month,
        ordersYear: year,
      });
      await this.$store.dispatch("getEmployeeAbsences", {
        employeeId: this.employeeId,
      });
      await this.$store.dispatch("getEmployeeAvailability", {
        employeeId: this.employeeId,
      });

      await this.$store.dispatch("getEmployeePaymentForMonth", {
        employeeId: this.employeeId,
        month: month,
        year: year,
      });

      await this.$store.dispatch("getEmployeeAttachments", {
        employeeId: this.employeeId,
      });

      this.settlementMonth = Number(month);
      this.settlementYear = Number(year);
      try {
        this.settlement = await this.$store.dispatch("getEmployeeSettlement", {
          employeeId: this.employeeId,
          month: Number(month),
          year: Number(year),
        });
      } catch (e) {
        this.settlement = null;
      }
    },
    openSettlement() {
      if (!this.settlement || !this.settlement.permissions.canEdit) return;
      this.settlementMode = this.isSettlementAdmin ? "manager" : "employee";
      this.settlementModalVisible = true;
    },
    onSettlementChanged() {
      this.fetchEmployeeData(this.settlementMonth, this.settlementYear);
    },
    formatDateTime(value) {
      const d = new Date(value);
      const p = (n) => String(n).padStart(2, "0");
      return `${p(d.getHours())}:${p(d.getMinutes())} ${p(d.getDate())}.${p(
        d.getMonth() + 1
      )}.${d.getFullYear()}`;
    },
    deleteAbsence(date) {
      if (
        confirm(
          ` Czy na pewno chcesz usunąć nieobecność opiekuna dnia: ${date}?`
        )
      ) {
        this.confirmDeleteEmployeeAbsence(date);
      }
    },

    async confirmDeleteEmployeeAbsence(date) {
      const employeeAbsence = this.employeeAbsences.find(
        (a) => moment(a.date).format("YYYY-MM-DD") === date
      );
      if (employeeAbsence) {
        const response = await this.$store.dispatch(
          "deleteEmployeeAbsence",
          employeeAbsence.id
        );
        if (response) {
          this.$notify({
            group: "success",
            text: "Niebecność opiekuna została usunięta",
          });

          await this.$store.dispatch("getEmployeeAbsences", {
            employeeId: this.employeeId,
          });

          this.selectedAbsence = null;
        }
      }
    },
    onDayClick(day) {
      this.lastClickedDay = day;
      let orderedCustomers = [];
      let employeeAbsencesDates = this.employeeAbsences.map((a) =>
        moment(a.date).format("YYYY-MM-DD")
      );

      this.employeeOrders.forEach((order) => {
        const numberOfScheduledHoursByDays = {};
        const orderDays = [];
        order.days.forEach((orderDay) => {
          const date = moment(day.date).format("YYYY-MM-DD");
          const orderDateDate = moment(orderDay.date).format("YYYY-MM-DD");
          if (orderDateDate === date) {
            orderDays.push(date);
            numberOfScheduledHoursByDays[date] = orderDay.numberOfHours;
          }
        });

        if (orderDays.includes(day.id)) {
          orderedCustomers.push({
            date: day.id,
            customer: `${order.customer.firstName} ${order.customer.lastName}`,
            numberOfScheduledHours: numberOfScheduledHoursByDays[day.id],
            customerId: order.customer.id,
            orderId: order.id,
          });
        }
      });
      if (orderedCustomers && orderedCustomers.length > 0) {
        this.selectedDayCustomers = orderedCustomers;
        this.selectedDayScheduled = false;
      } else {
        this.selectedDayCustomers = [];
        this.selectedDayScheduled = false;
      }

      if (employeeAbsencesDates.includes(day.id)) {
        this.selectedAbsence = day.id;
      } else {
        this.selectedAbsence = null;
      }
    },

    async onMonthChange() {
      let month = this.$refs["employeeCalendar"]._data.pages[0].month;
      const year = this.$refs["employeeCalendar"]._data.pages[0].year;
      if (month < 10) {
        month = "0" + month;
      }
      this.calendarMonth = `${year}-${month}`;

      await this.$store.dispatch("setEmployeeFetchParams", {
        ordersMonth: month,
        ordersYear: year,
      });

      await this.fetchEmployeeData(
        this.$refs["employeeCalendar"]._data.pages[0].month,
        year
      );
    },

    combineDatesByWeekday(startDate, endDate, weekdays) {
      moment.locale("en");
      const start = moment(startDate);
      const end = moment(endDate);

      const allDates = [];

      let current = start.clone();

      while (current.isSameOrBefore(end)) {
        allDates.push(current.format("YYYY-MM-DD"));
        current.add(1, "day");
      }

      const combinedDates = [];

      weekdays.forEach((day) => {
        const datesForWeekday = allDates.filter(
          (date) => moment(date).format("dddd").toUpperCase() === day
        );
        combinedDates.push(...datesForWeekday);
      });

      combinedDates.sort((a, b) => moment(a).diff(moment(b)));
      moment.locale("en");
      return combinedDates;
    },
  },

  computed: {
    employeeSumOfPayments() {
      return this.$store.getters.getDodSelectedEmployeeSumOfPayment;
    },
    isSettlementAdmin() {
      return this.$store.getters.getIsSettlementAdmin;
    },
    grossWage() {
      return this.settlement && this.settlement.wage
        ? this.settlement.wage.gross
        : this.employeeSumOfPayments;
    },
    hourlyRate() {
      return this.settlement && this.settlement.wage
        ? this.settlement.wage.hourlyRate
        : null;
    },
    numberOfUnrealizedHours() {
      if (this.settlement && this.settlement.counters) {
        return this.settlement.counters.unrealized;
      }
      return this.numberOfOrderedHours - this.numberOfMadeHours;
    },
    employeeAvailability() {
      return this.$store.getters.getDodSelectedEmployeeAvailability?.data
        ? this.$store.getters.getDodSelectedEmployeeAvailability?.data[0]
        : null;
    },
    employeeOrders() {
      return this.$store.getters.getDodSelectedEmployeeOrders?.data || [];
    },
    employeeAbsences() {
      return this.$store.getters.getDodSelectedEmployeeAbsences?.data || [];
    },

    scheduledAttributes() {
      return this.scheduledDaysInMonth && this.scheduledDaysInMonth.length > 0
        ? [
            {
              key: "scheduledEmployeeDays",
              dates: this.scheduledDaysInMonth,
              highlight: {
                color: "yellow",
                fillMode: "outline",
              },
            },
          ]
        : [];
    },

    scheduledDaysInMonth() {
      if (this.employeeAvailability && this.calendarMonth) {
        const selectedYear = this.calendarMonth.split("-")[0];
        const selectedMonth = this.calendarMonth.split("-")[1];
        const availability = { ...this.employeeAvailability };
        delete availability.holidays;
        delete availability.id;
        const weekdays = [];
        for (const [key, value] of Object.entries(this.employeeAvailability)) {
          if (value) {
            weekdays.push(key.toUpperCase());
          }
        }
        const monthStartDate = moment(
          `${selectedYear}-${selectedMonth}-01`,
          "YYYY-MM-DD",
          true
        ).toJSON();
        const monthEndDate = moment(
          `${selectedYear}-${selectedMonth}-01`,
          "YYYY-MM-DD",
          true
        )
          .endOf("month")
          .toJSON();

        const days = this.combineDatesByWeekday(
          monthStartDate,
          monthEndDate,
          weekdays
        );
        return days;
      } else {
        return [];
      }
    },

    orderedAttributes() {
      if (this.employeeOrders) {
        let attributes = [];
        this.employeeOrders.forEach((order) => {
          attributes.push({
            key: "ordered",
            dates: order.days.map((day) => day.date),
            highlight: "green",
            order: 1,
          });
        });
        return attributes;
      } else {
        return [];
      }
    },

    numberOfOrderedHours() {
      if (this.employeeOrders) {
        let numberOfHours = 0;
        this.employeeOrders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            numberOfHours = numberOfHours + day.numberOfHours;
          });
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },

    numberOfMadeHours() {
      if (this.employeeOrders) {
        let numberOfHours = 0;
        this.employeeOrders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            numberOfHours = numberOfHours + day.numberOfMadeHours;
          });
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },

    absencesAttributes() {
      if (this.employeeAbsences) {
        let orderedDates = [];
        this.orderedAttributes.forEach((orderedAttribute) => {
          const dates = orderedAttribute.dates;
          orderedDates = [...orderedDates, ...dates];
        });
        let attributes = [];
        attributes.push({
          key: "absences",
          dates: this.employeeAbsences
            .map((day) => day.date)
            .filter((d) => orderedDates.includes(d)),
          highlight: "red",
          order: 2,
        });

        attributes.push({
          key: "absences",
          dates: this.employeeAbsences
            .map((day) => day.date)
            .filter((d) => !orderedDates.includes(d)),
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          order: 2,
        });

        return attributes;
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  border: 0;
  border-bottom: 1px solid rgba(9, 7, 65, 0.25);
}
.left-side {
  width: 55%;
  display: flex;
  flex-direction: column;
  align-content: center;
}
.right-side {
  width: 45%;
  padding-left: 3rem;
}
.calendar {
  width: 100%;
}
.right-side p {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.data-label {
  font-weight: 600;
  margin-right: 1rem;
}
.change-schedule-label {
  margin-top: 1rem;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
  width: fit-content;
}
.scheduled-employee {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.scheduled-employee-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4rem;
}
.add-absence-button {
  text-decoration: underline;
  font-size: 14px;
  margin-top: 3rem;
  cursor: pointer;
  width: fit-content;
}
.selected-absence {
  font-size: 14px;
}
.delete-absence {
  color: rgb(235, 25, 25);
  text-decoration: underline;
  cursor: pointer;
  width: fit-content;
}
.availability-button {
  cursor: pointer;
  font-size: 13px;
  margin: 4rem 0;
  font-weight: 600;
  text-decoration: underline;
}
.customer-scheduled-days-info {
  font-size: 13px;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.last-change {
  font-size: 13px !important;
  color: #666;
  margin-top: -0.5rem;
}
.settlement-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 1rem;
}
.settlement-actions button {
  border: none;
  /* Pełny pill jak w Canvie; jednakowy rozmiar dla wszystkich akcji. */
  border-radius: 999px;
  height: 50px;
  width: 300px;
  padding: 10px 22px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
}
.btn-prepare,
.btn-edit {
  background: linear-gradient(90deg, #fb8928, #e50582);
}
.btn-history {
  background: #ececf4;
  color: #090741 !important;
}
.settlement-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.print-icon {
  width: 20px;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>